import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppConfig, CMPS_APP_CONFIG } from '../app.config';

import { AuthStatus } from './auth.model';
import { AuthService } from './auth.service';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
    constructor(
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
        private readonly _authService: AuthService,
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        // TODO revise. see calls to MatIconRegistry.addSvgIconSet
        if (
            req.url.endsWith('/assets/mdi.svg') ||
            req.url.startsWith(
                `${this._appConfig.OAUTH.AUTHORIZATION_ENDPOINT}/connect/token`,
            ) ||
            this._authService.authStatus.value !== AuthStatus.AUTHENTICATED
        ) {
            return next.handle(req);
        }

        return next.handle(
            req.clone({
                headers: req.headers.set(
                    'Authorization',
                    `${this._authService.user.token.token_type} ${this._authService.user.token.access_token}`,
                ),
            }),
        );
    }
}
